export const CasinoDom = {
  MODAL_CONTAINER: 'casino-game-view-modal-container'
};
